import Head from "next/head"
import { isEmpty } from "ramda"
import React from "react"
import { Maybe, MerchantInfoQueryIcons } from "../../../../graphql/generated-types"
import { MetadataIcons } from "./MetadataComponentWrapper"
import { getOnlineOrderingTitle } from "./utils"

interface Props {
    accountName?: Maybe<string>
    locationName?: Maybe<string>
    themeColor?: string
    jsonManifest: {
        name: string
        short_name: string
        description: string
        // start_url: string
        background_color: string
        display: string
        icons: Maybe<MerchantInfoQueryIcons[]>
    }
    metadataIcons: Maybe<MetadataIcons>
}

class MetadataComponent extends React.PureComponent<Props> {
    render() {
        const { fallbackIcon, appleTouchIcon, favIcon32, favIcon16, msTileImage } = this.props.metadataIcons

        return (
            <>
                <Head>
                    {this.props.jsonManifest && (
                        <link
                            rel="manifest"
                            href={`data:application/manifest+json,${JSON.stringify(this.props.jsonManifest)}`}
                        />
                    )}
                    {this.props.themeColor && <meta name="msapplication-TileColor" content={this.props.themeColor} />}
                    {this.props.themeColor && <meta name="theme-color" content={this.props.themeColor} />}

                    {isEmpty(this.props.metadataIcons) && (
                        <link rel="mask-icon" href="/assets/icons/safari-pinned-tab.svg" color="#5bbad5" />
                    )}

                    {!favIcon16 && !favIcon32 && fallbackIcon ? (
                        <link rel="shortcut icon" type="image/png" href={fallbackIcon.src} />
                    ) : (
                        <>
                            <link
                                rel="icon"
                                type="image/png"
                                sizes="32x32"
                                href={favIcon32 ? favIcon32.src : "/assets/icons/favicon-32x32.png"}
                            />
                            <link
                                rel="icon"
                                type="image/png"
                                sizes="16x16"
                                href={favIcon16 ? favIcon16.src : "/assets/icons/favicon-16x16.png"}
                            />
                        </>
                    )}

                    <link
                        rel="apple-touch-icon"
                        sizes="180x180"
                        href={appleTouchIcon ? appleTouchIcon.src : "/assets/icons/apple-touch-icon.png"}
                    />
                    <meta
                        name="msapplication-TileImage"
                        content={msTileImage ? msTileImage.src : "/assets/icons/mstile-150x150.png"}
                    />

                    <title>
                        {getOnlineOrderingTitle(this.props.accountName, this.props.locationName, " | Online Ordering")}
                    </title>
                </Head>
            </>
        )
    }
}

export default MetadataComponent
